import {
  daysJsFormat,
  formatCurrency,
  roles,
  typeIntervention,
} from "../../../utils/constants";
import { AiFillCalendar } from "react-icons/ai";
import { PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { HiOutlineMail } from "react-icons/hi";
import React from "react";
import dayjs, { dateCustomFormat } from "../../../utils/dayjs";
import { onlyRoleMapping, userHasLevel } from "../../../engine/AuthRoute";
import routes from "../../../engine/routes";
import ReactJson from "react-json-view";

import {
  disabledDateNext12Months,
  disabledDatePast,
  validateTimeBetween,
} from "../../../shared/components/CustomForm/form.helpers";
import { t } from "i18next";
import {
  renderAdress,
  typeAddress,
} from "../../../shared/container/Addresses/AddresseItem/AddresseHelpers";
import { DurationHourChecker } from "../PrestationDetail/DurationHourChecker";
import { formAmountBillet } from "./prestation.amountbillet";

export const prestationInputs = (prestation, configuration, user) => {
  const {
    intervention: { startDate, endDate, location, extra },
    interventionFinal,
    institution,
    intervenant,
    intervenantFinal,
    intervention,
    applicationAt,
    responsable,
    beneficiary,
    noSharedCost,
    noTransportCost,
    amountBillet,
  } = prestation;

  const disabledDate = current => {
    if (onlyRoleMapping([roles.institution, roles.interprete])) {
      return disabledDatePast(current) || disabledDateNext12Months(current);
    } else {
      return false;
    }
  };

  // function generateSBBLinkWithAddresses(
  //   fromAddress,
  //   toAddress,
  //   date,
  //   time,
  //   moment = "ARRIVAL", // ARRIVAL
  // ) {
  //   const baseURL = "https://www.sbb.ch/en";
  //   const encodedFrom = encodeURIComponent(fromAddress);
  //   const encodedTo = encodeURIComponent(toAddress);
  //   const encodedDate = encodeURIComponent(`"${date}"`);
  //   const encodedTime = encodeURIComponent(`"${time}"`);
  //   const encodedMoment = encodeURIComponent(`"${moment}"`);
  //
  //   return `${baseURL}?von=${encodedFrom}&nach=${encodedTo}&date=${encodedDate}&time=${encodedTime}&moment=${encodedMoment}`;
  // }
  //
  // // Exemple d'utilisation
  // const fromAddress = prestation.intervention.locationFrom;
  // const toAddress = prestation.intervention.location;
  // const travelDate = dayjs(prestation?.cff?.dateUsed).format(daysJsFormat.day);
  // const travelTime = dayjs(prestation?.cff?.dateUsed).format(daysJsFormat.hour);
  //
  // const sbbLink = generateSBBLinkWithAddresses(
  //   fromAddress,
  //   toAddress,
  //   travelDate,
  //   travelTime,
  // );

  return [
    {
      parentLabel: "",
      children: [
        {
          disabledDate,
          required: true,
          rules: [
            refValidator => ({
              validator(_) {
                return validateTimeBetween(
                  refValidator,
                  "interventionFinal.startDate",
                  "interventionFinal.endDate",
                  user,
                  false,
                  false,
                );
              },
            }),
          ],
          label: t("prestationResumeForm.realStartDateTime"),
          name: "interventionFinal.startDate",
          value:
            interventionFinal.startDate === null
              ? dayjs(startDate)
              : dayjs(interventionFinal.startDate),
          suffixIcon: <AiFillCalendar />,
          showTime: true,
          type: "date-time",
          col: 12,
        },
        {
          disabledDate,
          required: true,
          label: t("prestationResumeForm.realEndDateTime"),
          name: "interventionFinal.endDate",
          rules: [
            refValidator => ({
              validator(_) {
                return validateTimeBetween(
                  refValidator,
                  "interventionFinal.startDate",
                  "interventionFinal.endDate",
                  user,
                  false,
                  false,
                );
              },
            }),
          ],
          value:
            interventionFinal.endDate === null
              ? dayjs(endDate)
              : dayjs(interventionFinal.endDate),
          suffixIcon: <AiFillCalendar />,
          showTime: true,
          type: "date-time",
          col: 12,
        },
        {
          col: 24,
          type: "component",
          name: "durationHour",
          noWrapper: true,
          component: ({ refForm }) => (
            <DurationHourChecker
              keys={[
                "interventionFinal.startDate",
                "interventionFinal.endDate",
              ]}
              isLongDuration={prestation.isLongDuration}
            />
          ),
        },
        {
          visible: userHasLevel({
            only: {
              [roles.permanance]: "r", //
              [roles.admin]: "r", //
              [roles.institution]: "r", //
            },
          }),
          label: t("prestationResumeForm.applicationSubmissionDate"),
          name: "applicationAt",
          required: true,
          value: applicationAt === null ? null : dayjs(applicationAt),
          showTime: true,
          type: "date-time",
          col: 12,
        },
        intervention.type === typeIntervention.in_person
          ? {
              required: true,
              label: t("prestationResumeForm.realInterventionAddress"),
              name: "interventionFinal.location",
              value: interventionFinal?.location
                ? interventionFinal.location
                : prestation.intervention.location,
              type: "google-adress",
              col: 24,
            }
          : {},
        // {
        //   label: t("prestationResumeForm.noSharedCost"),
        //   name: "noSharedCost",
        //   visible: userHasLevel({
        //     only: {
        //       [roles.admin]: "r", //
        //       [roles.permanance]: "r", //
        //     },
        //   }),
        //   type: "checkbox-bool",
        //   value: noSharedCost,
        //   col: 24,
        // },
        {
          label: t("prestationResumeForm.noTransportCost"),
          name: "noTransportCost",
          visible: userHasLevel({
            only: {
              [roles.admin]: "r", //
              [roles.permanance]: "r", //
            },
          }),
          type: "checkbox-bool",
          value: noTransportCost,
          col: 24,
        },

        intervention.type === typeIntervention.in_person
          ? {
              visible: userHasLevel({
                only: {
                  [roles.admin]: "r", //
                },
              }),
              label: t("prestationResumeForm.realInterpreterDepartureLocation"),
              name: "interventionFinal.locationFrom",
              className: "non-printable",
              value: interventionFinal?.locationFrom
                ? interventionFinal.locationFrom
                : prestation.intervention.locationFrom || "",
              type: "google-adress",
              col: 24,
            }
          : {},
        formAmountBillet({
          amountBillet,
          t,
          prestation,
        }),
        {
          label: t("prestationResumeForm.billingAddress"),
          name: "billing",
          visible: userHasLevel({
            only: {
              [roles.permanance]: "r", //
              [roles.admin]: "r", //
            },
          }),
          addonBefore: <UserOutlined />,
          quote: (
            <>
              <p>{t("prestationResumeForm.editOnInstitutionPage")}</p>
              <a
                target={"_blank"}
                href={
                  routes.institutions(prestation?.institution?._id).addresses
                    .path
                }
              >
                {t("prestationResumeForm.editAddresses")}
              </a>
            </>
          ),
          quoteIcon: "info",
          type: "dynamic-select",
          required: true,
          value: prestation.billing === null ? null : prestation.billing._id,
          multiple: false,
          endPoint: `addresses?institution=${prestation?.institution?._id}&type=${typeAddress.postal}`,
          itemsCallBack: addresses => {},
          inputSize: "large",
          noSorting: true,
          itemCallback: adress => {
            return {
              key: adress._id,
              label: renderAdress(
                adress,
                prestation?.institution?.defaultAddress === adress._id,
                prestation?.institution,
              ),
              value: adress._id,
            };
          },
          col: 24,
        },
      ],
    },
    {
      parentLabel: t("prestationResumeForm.beneficiaryReferenceInfo"),
      description: t("prestationResumeForm.beneficiaryInfoDescription"),
      children: [
        {
          label: t("prestationResumeForm.beneficiaryReference"),
          name: "beneficiary.reference",
          type: "input",
          col: 24,
        },
        {
          label: t("prestationResumeForm.beneficiaryLastName"),
          name: "beneficiary.firstname",
          type: "input",
          // visible:
          //   beneficiary.firstname.length > 0 || beneficiary.lastname.length > 0,
          col: 24,
        },
        {
          label: t("prestationResumeForm.beneficiaryFirstName"),
          name: "beneficiary.lastname",
          type: "input",
          // visible:
          //   beneficiary.firstname.length > 0 || beneficiary.lastname.length > 0,
          col: 24,
        },
        {
          label: t("prestationResumeForm.beneficiaryCountry"),
          name: "beneficiary.country",
          type: "input",
          col: 24,
        },
        configuration?.prestation?.beneficiairyHasBirthdate === true
          ? {
              label: t("prestationResumeForm.beneficiaryDate"),
              name: "beneficiary.birthday",
              type: "input",
              value: beneficiary.birthday,
              // visible: beneficiary.birthday !== undefined,
              col: 12,
            }
          : null,
        {
          label: t("prestationInputs.gender"),
          name: "beneficiary.genre",
          type: "select",
          multiple: false,
          allowClear: true,
          selectContent: [
            { label: t("prestationInputs.femaleG"), value: "female" },
            { label: t("prestationInputs.maleG"), value: "male" },
          ],
          col: 12,
        },
        {
          label: t("prestationResumeForm.beneficiarysimic"),
          name: "beneficiary.simic",
          type: "input",
          // visible:
          //   beneficiary.firstname.length > 0 || beneficiary.lastname.length > 0,
          col: 12,
        },
        {
          label: t("prestationResumeForm.beneficiaryn"),
          name: "beneficiary.n",
          type: "input",
          // visible:
          //   beneficiary.firstname.length > 0 || beneficiary.lastname.length > 0,
          col: 12,
        },
      ],
    },
    {
      parentLabel: t("prestationResumeForm.interviewResponsiblePersonnel"),
      children: [
        {
          placeholder: t("prestationResumeForm.lastName"),
          value: responsable?.lastname,
          name: "responsable.lastname",
          type: "input",
          required: true,
          addonBefore: <UserOutlined />,
          col: 12,
        },
        {
          placeholder: t("prestationResumeForm.firstName"),
          value: responsable?.firstname,
          name: "responsable.firstname",
          required: true,
          addonBefore: <UserOutlined />,
          type: "input",
          col: 12,
        },
        {
          placeholder: t("prestationResumeForm.email"),
          value: responsable?.email,
          name: "responsable.email",
          addonBefore: <HiOutlineMail />,
          type: "input",
          col: 12,
        },
        {
          placeholder: t("prestationResumeForm.phone"),
          value: responsable?.phone,
          name: "responsable.phone",
          addonBefore: <PhoneOutlined />,
          type: "input",
          col: 12,
        },
        {
          label: t("prestationResumeForm.remark"),
          name: "interventionFinal.note",
          addonBefore: <HiOutlineMail />,
          placeholder: t("prestationResumeForm.remark"),
          type: "textarea",
          col: 24,
        },
      ],
    },
  ];
};
